export default __webpack_public_path__ + "static/media/004.42721ac3.jpg";